import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Col,
  Form,
  Row,
  Card,
  Divider,
  Checkbox,
  Button,
  Radio,
  Typography,
} from "antd";
import { CreditCardOutlined } from "@ant-design/icons";

const { Title } = Typography;

const StepPay = ({ form, formData }) => {
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    if (formData?.charges && formData?.items) {
      const subtotal = formData.items.reduce(
        (acc, item) => acc + (item.value || 0) * (item.quantity || 1),
        0
      );
      const shippingCharge =
        formData.charges.find((ch) => ch.type.includes("Shipping"))?.amount ||
        0;
      const insuranceCharge =
        formData.charges.find((ch) => ch.type.includes("Insurance"))?.amount ||
        0;
      const discount = 20;

      setTotalAmount(subtotal + shippingCharge + insuranceCharge - discount);
    }
  }, [formData]);

  return (
    <Form form={form} layout="vertical">
      <Card
        title={
          <Title level={4} style={{ margin: 0 }}>
            Shipment Cost Summary
          </Title>
        }
        style={{ marginBottom: "20px" }}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <p>
              <strong>Service:</strong>{" "}
              {formData?.serviceName || "EXPRESS WORLDWIDE"}
            </p>
            <p>Estimated Delivery: {new Date().toLocaleDateString()}</p>
            <p>
              <strong>Total Weight:</strong> {formData?.totalWeight || "0.5"} kg
            </p>
          </Col>
          <Col span={12}>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li>
                <strong>Transportation Charges:</strong> $
                {formData?.charges?.find((ch) => ch.type.includes("Shipping"))
                  ?.amount || "669.00"}
              </li>
              <li>
                <strong>Shipment Protection:</strong> $
                {formData?.charges?.find((ch) => ch.type.includes("Insurance"))
                  ?.amount || "100.00"}
              </li>
              <li
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#1890ff",
                }}
              >
                <strong>Total:</strong> ${totalAmount.toFixed(2)}
              </li>
            </ul>
          </Col>
        </Row>
        <Divider />
        <Checkbox>
          Billing address is the same as the ship FROM address
        </Checkbox>
      </Card>

      <Card
        title={
          <Title level={4} style={{ margin: 0 }}>
            Payment Options
          </Title>
        }
      >
        <Radio.Group
          value={selectedPayment}
          onChange={(e) => setSelectedPayment(e.target.value)}
          style={{ width: "100%" }}
        >
          <Row gutter={[16, 16]} align="middle">
            <Col span={8}>
              <Radio value="Visa">
                <CreditCardOutlined /> Visa
              </Radio>
            </Col>
            <Col span={8}>
              <Radio value="MasterCard">
                <CreditCardOutlined /> MasterCard
              </Radio>
            </Col>
            <Col span={8}>
              <Radio value="Amex">
                <CreditCardOutlined /> American Express
              </Radio>
            </Col>
          </Row>
        </Radio.Group>
      </Card>

      <Divider />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        <Button
          type="primary"
          size="large"
          disabled={!selectedPayment}
          style={{ backgroundColor: selectedPayment ? "#28a745" : "#d9d9d9" }}
        >
          Accept and Pay
        </Button>
      </div>
    </Form>
  );
};

StepPay.propTypes = {
  form: PropTypes.object.isRequired,
  formData: PropTypes.object,
};

StepPay.defaultProps = {
  formData: {},
};

export default StepPay;
